/** Zahlen der Ernaehrung (F-35): kcal ganz, Gramm mit einer Nachkommastelle. */
import { MAKROS, MIKROS, type MakroKey, type Mikro } from '@/domain/ernaehrung/typen';

export const zahl = (v: number | undefined, stellen = 1) => (v === undefined ? '–' : v.toLocaleString('de-DE', { maximumFractionDigits: stellen }));
export const kcal = (v: number | undefined) => (v === undefined ? '–' : `${Math.round(v).toLocaleString('de-DE')} kcal`);
export const mitEinheit = (k: MakroKey | Mikro, v: number | undefined) => {
  if (v === undefined) return '–';
  if (k in MAKROS) return MAKROS[k as MakroKey].einheit === 'kcal' ? kcal(v) : `${zahl(v)} g`;
  return `${zahl(v)} ${MIKROS[k as Mikro].einheit}`;
};
